import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductCategoryService } from 'src/app/shared/store/product-category/product-category.service';
import { ProductLineService } from 'src/app/shared/store/product-line/product-line.service';
import { ProductLineModel } from 'src/app/shared/store/product-line/types';

@Component({
    selector: 'app-product-line-details-insurance-documents',
    templateUrl: './product-line-details-insurance-documents.component.html',
    styleUrls: ['./product-line-details-insurance-documents.component.scss'],
    standalone: false
})
export class ProductLineDetailsInsuranceDocumentComponent {
  productLine$: Observable<ProductLineModel>;

  constructor(private readonly productLineService: ProductLineService) {
    this.productLine$ = this.productLineService.getById.value$;
  }
}
